module.exports = __webpack_public_path__ + "static/IBMPlexSans-SemiBold-d62ec9c095336020f16f5ecce0ef45cc.woff";